// src/.../PatientMapComp/Filters/PatientMapFilters.jsx
import React , { useState } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Card,
  CardContent,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const locationOptions = [
  { id: 1, name: "FortMyers" },
  { id: 2, name: "FortPierce" },
  { id: 3, name: "Immokalee" },
  { id: 4, name: "Lehigh" },
  { id: 5, name: "Naples" },
  { id: 6, name: "LakeWorth" },
  { id: 7, name: "Port Saint Lucie" },
  { id: 8, name: "Unassigned" },
];

const memberTypeOptions = [
  { label: "MED", value: "MED" },
  { label: "ACA", value: "ACA" },
];

const genderOptions = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
];

const pcpOptions = [
  { label: "Dr. ALCIN, ANEILLA",              value: "ALCIN, ANEILLA (CREOLE & ENG)" },
  { label: "Dr. AWAIS SIDDIKI",                value: "AWAIS SIDDIKI" },
  { label: "Dr. DHILLON-GILL, RAMANDEEP",      value: "DHILLON-GILL, RAMANDEEP (HINDU &ENGLISH)" },
  { label: "Dr. GASPARD, RICARDO",             value: "GASPARD, RICARDO (CREOLE & ENG)" },
  { label: "Dr. JEAN MESIDOR",                 value: "JEAN MESIDOR" },
  { label: "Dr. JOHN EDMOND",                  value: "JOHN EDMOND (CREOLE & ENG)" },
  { label: "Dr. JOLIVAIN, ANN",                value: "JOLIVAIN, ANN (CREOLE & ENGLISH)" },
  { label: "Dr. LOUIS JEAN MARTELLY, YOLETTE", value: "LOUIS JEAN MARTELLY, YOLETTE (CREOLE & ENG)" },
  { label: "Dr. MOLINA-CHUY, YANELA",          value: "MOLINA-CHUY, YANELA (SPANISH & ENG)" },
  { label: "Dr. MOYSE, JOSEPH",                value: "MOYSE, JOSEPH (SPANISH,CREOLE,ENG)" },
  { label: "Dr. NAVARO, NELIUDIS",             value: "NAVARO, NELIUDIS (SPANISH & ENG)" },
  { label: "Dr. PENA SANCHEZ, ORLY",           value: "PENA SANCHEZ, ORLY ( SPANISH & ENG)" },
  { label: "Dr. PEZZOTTI, REYNALDO PEZZOTTI",  value: "PEZZOTTI, REYNALDO PEZZOTTI(SPANISH & ENG)" },
  { label: "Dr. PORRAS, BELKYS",               value: "PORRAS, BELKYS (SPANISH & ENG)" },
  { label: "Dr. RAKIA HAMILTON",               value: "RAKIA HAMILTON (ENGLISH ONLY)" },
  { label: "Dr. RENELIEN, JEAN L",             value: "RENELIEN, JEAN L (CREOLE & ENG)" },
  { label: "Dr. ROBERT SADATY",                value: "ROBERT SADATY (ENGLISH)" },
  { label: "Dr. ROBERT, CHARLES",              value: "ROBERT, CHARLES (CREOLE & ENG)" },
  { label: "Dr. SIDDIKI, AWAIS",               value: "SIDDIKI, AWAIS ( HINDU & ENG)" },
  { label: "Dr. SMITH WANDA",                  value: "SMITH WANDA (SPANISH & ENG)" },
  { label: "Dr. VIVIANA PERDOMO",              value: "VIVIANA PERDOMO (SPANISH & ENGLISH)" },
  { label: "Dr. YOHANNA DENO",                 value: "YOHANNA DENO (SPANISH, ENGLISH)" }
];

const PatientMapFilters = ({
  memberFullName, setMemberFullName,
  locationId,      setLocationId,
  memberType,      setMemberType,
  pcpName,         setPcpName,
  gender,          setGender,
  ageFrom,         setAgeFrom,
  ageTo,           setAgeTo,
  // 👇 nuevos filtros booleanos
  filterAdmitted,      setFilterAdmitted,
  filterDischarged,    setFilterDischarged,
  filterEmergency,     setFilterEmergency,
  filterHighCost,      setFilterHighCost,
  filterHighRisk,      setFilterHighRisk,
  onApply
}) => {
  const [localSearch, setLocalSearch] = useState("");

  const handleApply = () => {
    // si quisieras usar localSearch, aquí harías:
    // setMemberFullName(localSearch);
    onApply();
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent sx={{ width: "100%" }}>
        <Grid container spacing={2} alignItems="center">
          {/* Search Field */}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <TextField
              fullWidth
              label="Search by Name or CIP_ID"
              variant="outlined"
              size="small"
              value={memberFullName ?? ""}
              onChange={e => setMemberFullName(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {/* Location */}
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <FormControl fullWidth size="small" sx={{ minWidth: 160 }}>
              <InputLabel>Location</InputLabel>
              <Select
                label="Location"
                value={locationId ?? ""}
                onChange={e =>
                  setLocationId(e.target.value ? +e.target.value : null)
                }
              >
                <MenuItem value=""><em>All</em></MenuItem>
                {locationOptions.map(loc => (
                  <MenuItem key={loc.id} value={loc.id}>{loc.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Member Type */}
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <FormControl fullWidth size="small" sx={{ minWidth: 160 }}>
              <InputLabel>Member Type</InputLabel>
              <Select
                label="Member Type"
                value={memberType ?? ""}
                onChange={e => setMemberType(e.target.value || null)}
              >
                <MenuItem value=""><em>All</em></MenuItem>
                {memberTypeOptions.map(o => (
                  <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* PCP */}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth size="small" sx={{ minWidth: 160 }}>
              <InputLabel>PCP</InputLabel>
              <Select
                label="PCP"
                value={pcpName ?? ""}
                onChange={e => setPcpName(e.target.value || null)}
              >
                <MenuItem value=""><em>All</em></MenuItem>
                {pcpOptions.map(o => (
                  <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Gender */}
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <FormControl fullWidth size="small" sx={{ minWidth: 160 }}>
              <InputLabel>Gender</InputLabel>
              <Select
                label="Gender"
                value={gender ?? ""}
                onChange={e => setGender(e.target.value || null)}
              >
                <MenuItem value=""><em>All</em></MenuItem>
                {genderOptions.map(o => (
                  <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Age From */}
          <Grid item xs={6} sm={3} md={2} lg={1.5}>
            <TextField
              fullWidth
              label="Age From"
              variant="outlined"
              size="small"
              type="number"
              value={ageFrom ?? ""}
              onChange={e => setAgeFrom(e.target.value ? +e.target.value : null)}
            />
          </Grid>

          {/* Age To */}
          <Grid item xs={6} sm={3} md={2} lg={1.5}>
            <TextField
              fullWidth
              label="Age To"
              variant="outlined"
              size="small"
              type="number"
              value={ageTo ?? ""}
              onChange={e => setAgeTo(e.target.value ? +e.target.value : null)}
            />
          </Grid>

          {/* ✅ Filtros booleanos (checklist) */}
          <Grid item xs={12}>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!filterHighCost}
                    onChange={(e) =>
                      setFilterHighCost(e.target.checked ? true : null)
                    }
                  />
                }
                label="High Cost"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!filterHighRisk}
                    onChange={(e) =>
                      setFilterHighRisk(e.target.checked ? true : null)
                    }
                  />
                }
                label="High Risk"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!filterAdmitted}
                    onChange={(e) =>
                      setFilterAdmitted(e.target.checked ? true : null)
                    }
                  />
                }
                label="Admitted"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!filterDischarged}
                    onChange={(e) =>
                      setFilterDischarged(e.target.checked ? true : null)
                    }
                  />
                }
                label="Discharged"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!filterEmergency}
                    onChange={(e) =>
                      setFilterEmergency(e.target.checked ? true : null)
                    }
                  />
                }
                label="Emergency"
              />
            </Box>
          </Grid>

          {/* Apply Button */}
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleApply}
              sx={{ height: "40px" }}
            >
              Apply Filters
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PatientMapFilters;
